import type { TourConfig } from "~/features/onboarding/types/tour-config";

// AIDEV-NOTE: Tour configuration for introducing practitioners to the consultation feature
// Shows up on the practitioner sessions page to highlight the Consult button

export const consultationTourConfig: TourConfig = {
    id: "consultation-tour",
    page: "/practitioner/sessions",

    welcome: {
        title: "Introducing: Professional Consultation",
        description:
            "Get expert guidance on your sessions through AI-powered consultation. Chat with an IFS expert consultant or receive a formal assessment of your guidance approach.",
        startButtonText: "Show Me",
        skipButtonText: "Maybe Later",
    },

    steps: [
        {
            id: "consult-button",
            targetSelector: "[data-tour-id='consult-button']",
            title: "Professional Consultation",
            content:
                "Click 'Consult' on any client session to chat with an expert IFS consultant or generate a formal assessment of your guidance approach. Perfect for reflection, learning, and improving your practice.",
            position: "left",
        },
    ],
};
